// Mapa prefijo-de-link → feature opcional. FUENTE ÚNICA del gating de menú por
// feature: el front (mixins/base.js · getMenuTree) oculta las páginas cuyo Link
// empieza por el prefijo cuando su feature está off, y el e2e lo refleja para
// saltar/afirmar-404 esos mismos recorridos (e2e/helpers/features.ts).
//
// Añadir un módulo opcional nuevo = una sola edición aquí. Si esto y el espejo del
// e2e divergen, los smoke de ese módulo fallan (página 404) → drift auto-detectable.

/** @type {Record<string, string>} feature → prefijo de Link (con barra final). */
export const FEATURE_MENU_PREFIX = { sii: "facturacion/", signatures: "firma/" };
